export enum AppOriginEnum {
  MyFF = 'MyFF',
}

export type AppOriginEnumType = keyof typeof AppOriginEnum;
